import React, { useState } from 'react'
import { buildEmbedUrl, secondsToHhmmss } from '../../utils/commonFunctions';
import "./ASK_Allama.css"
import { askAllamaBaseURL, search } from '../../backend/backendApis';
import HttpService from '../../backend/requestApis';
import { use } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import { imgContainer, imgStyle } from '../formStyle';

const ASK_Allama = () => {

  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  const [results, setResults] = useState([]);
  const [exactResults, setExactResults] = useState([]);
  const [resultIndex, setResultIndex] = useState(0);
  const [allResultsOpen, setAllResultsOpen] = useState(false);
  const [copiedTranscript, setCopiedTranscript] = useState(false);

  async function handleSearch(e) {
    e.preventDefault();
    const q = query.trim();
    if (!q) {
      setError("Please enter a question first.");
      return;
    }
    setError("");
    setStatus("");
    setLoading(true);
    setResults([]);
    setExactResults([]);
    setResultIndex(0);
    try {
        let options = {
            baseUrl:  askAllamaBaseURL,
            url: search,
            method: 'POST',
            payload:{
                "query": q
            },
            headers: {
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }
            }
        }

        HttpService(options).then(data => {
            console.log(data);
            const res = data?.data?.results || [];
            const exact = data?.data?.exact_results || [];
            setResults(res);
            setExactResults(exact);
            setResultIndex(0);
            setLoading(false);
            if (res.length === 0) {
                setStatus("No results found for your question.");
            }
        }).catch(err => {
            console.log('Error: ', err)
            if (err.response?.status === 403) {
                localStorage.clear();
                setLoading(false);
                navigate("/signUp");
            } else {
              setError(() => err?.response?.data?.detail?.msg ||err?.message || 'Error in searching. Please Contact Support.')
            }
            setLoading(false)    
        })
    //   await search(q, authEnabled ? token : null);
      
    } catch (err) {
      setLoading(false);
      console.error(err);
      if (err.response?.status === 403) {
        setError("You are not allowed to search.");
      } else if (err.response?.status === 401) {
        setError("Token invalid or expired. Please log in again.");
      } else {
        setError(err.response?.data?.detail || err.message || "Search failed.");
      }
    }
  }

  const current = results[resultIndex];
  const exactCurrent = exactResults[resultIndex];
  const hasResults = results.length > 0;

  async function copyTranscript() {
    const text = current?.transcript_snippet ?? "";
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopiedTranscript(true);
      setTimeout(() => setCopiedTranscript(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  }

  return (
    <div className="app-wrap">
      <div className="layout">
        <div style={{ ...imgContainer, padding: "0.4rem" }}>
          <img
            src={require("../../assets/images/WORK_logo.png")}
            alt="Logo"
            style={{...imgStyle, width: '20%'}}
          ></img>
        </div>
        <header className="header">
          <h3 className="title">Ask Allama Sir</h3>
          <p className="tagline">— Your Personal Allama</p>
        </header>

        <main className="main">
          <section className="search-section">
            <form onSubmit={handleSearch} className="search-form" role="search">
              <label htmlFor="query" className="sr-only">
                Your question
              </label>
              <input
                id="query"
                type="text"
                className="search-input"
                placeholder="e.g. How are humans created? Are they created from monkeys?"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoComplete="off"
              />
              <button
                type="submit"
                className="search-btn"
              >
                Search
              </button>
            </form>
          </section>


          {error && <div className="error-box">{error}</div>}
          {status && !error && <p className="status-text">{status}</p>}
          
          {loading && <Loader></Loader> }
          {hasResults && !loading && (
            <section className="results-section" aria-hidden="false">
              <p className="video-counter">
                <span className="video-counter-label">
                  Video {resultIndex + 1} of {results.length}
                </span>
                {typeof current?.score === "number" && (
                  <span className="video-counter-similarity">
                    Result similarity: {(Math.round(current.score * 1000) / 1000).toFixed(3)}
                  </span>
                )}
              </p>

              {exactCurrent && exactCurrent.url != null && (
                <div className="exact-match-section">
                  <div className="exact-match-label">Exact match</div>
                  <div className="exact-match-player-wrap">
                    <div className="embed-wrap embed-small">
                      <iframe
                        title="Exact match clip"
                        src={buildEmbedUrl(
                          exactCurrent.url,
                          exactCurrent.start,
                          exactCurrent.end,
                          true
                        )}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>
                    <p className="exact-match-time">
                      {secondsToHhmmss(exactCurrent.start)} → {secondsToHhmmss(exactCurrent.end)}
                    </p>
                  </div>
                </div>
              )}

              <div className="explanation-section">
                <div className="explanation-label">Explanation with context</div>
                <div className="explanation-player-wrap">
                  <div className="embed-wrap embed-main">
                    <iframe
                      title="Video with context"
                      src={buildEmbedUrl(
                        current?.url,
                        current?.start ?? 0,
                        current?.end ?? 0,
                        false
                      )}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>

              <div className="card transcript-card">
                <div className="transcript-card-header">
                  <h2 className="card-title">Transcript</h2>
                  <button
                    type="button"
                    className="btn btn-outline btn-copy-transcript"
                    onClick={copyTranscript}
                    disabled={!current?.transcript_snippet}
                    title="Copy transcript text"
                  >
                    {copiedTranscript ? "Copied!" : "Copy all transcript text"}
                  </button>
                </div>
                <div className="transcript-wrap">
                  <pre className="transcript">
                    {current?.transcript_snippet ?? "No transcript available."}
                  </pre>
                </div>
              </div>

              <div className="meta-row">
                <span className="meta">
                  Start: {current ? secondsToHhmmss(current.start) : "—"}
                </span>
                <span className="meta">
                  End: {current ? secondsToHhmmss(current.end) : "—"}
                </span>
                <span className="meta">
                  Duration: {current ? `${Math.round((current.end - current.start) * 10) / 10}s` : "—"}
                </span>
              </div>

              <nav className="nav" aria-label="Result navigation">
                <button
                  type="button"
                  className="nav-btn"
                  disabled={resultIndex === 0}
                  onClick={() => setResultIndex((i) => Math.max(0, i - 1))}
                >
                  Previous
                </button>
                <span className="nav-counter">
                  Video {resultIndex + 1} / {results.length}
                </span>
                <button
                  type="button"
                  className="nav-btn"
                  disabled={resultIndex >= results.length - 1}
                  onClick={() =>
                    setResultIndex((i) => Math.min(results.length - 1, i + 1))
                  }
                >
                  Next
                </button>
              </nav>

              <details
                className="all-results"
                open={allResultsOpen}
                onToggle={(e) => setAllResultsOpen(e.target.open)}
              >
                <summary>View all results</summary>
                <ul className="all-results-list">
                  {results.map((v, i) => (
                    <li key={i} className={i === resultIndex ? "current" : ""}>
                      {i + 1}. {v.url} ({v.start}s – {v.end}s)
                      {typeof v.score === "number" &&
                        ` · similarity ${(Math.round(v.score * 1000) / 1000).toFixed(3)}`}
                      {i === resultIndex && " ▶ Currently playing"}
                    </li>
                  ))}
                </ul>
              </details>
            </section>
          )}
        </main>
      </div>
    </div>
  )
}

export default ASK_Allama
